import { render, staticRenderFns } from "./SmsEditor.vue?vue&type=template&id=332fa979&scoped=true&"
import script from "./SmsEditor.vue?vue&type=script&lang=js&"
export * from "./SmsEditor.vue?vue&type=script&lang=js&"
import style0 from "./SmsEditor.vue?vue&type=style&index=0&id=332fa979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332fa979",
  null
  
)

export default component.exports